// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "additional-qw9c_";
var _4 = "collapse-3F5th";
var _5 = "step-2WkVh";
var _6 = "expand-3Emxn";
var _7 = "disabled-2q3DA";
var _8 = "step__nameIndex-16Mxq";
var _9 = "stepContent__wrapper-2TceO";
var _a = "stepContent__footer-xjWeE";
var _b = "stepContent__segmentMoney-2uuNV";
var _c = "stepContent__segmentPrice-2rEAv";
var _d = "stepContent__headerText-9nKWe";
var _e = "stepContent__headerText_flights-2pqa_";
var _f = "step__nameLabel-3Xt4s";
var _10 = "step__innerPrice-3GLcX";
var _11 = "stepContent__segmentHeaderBaggage-170m4";
var _12 = "step__price-2shJK";
var _13 = "price-2s-vR";
var _14 = "stepContent__contentIcon-31BsZ";
export { _1 as "__esModule", _2 as "mobile", _3 as "additional", _4 as "collapse", _5 as "step", _6 as "expand", _7 as "disabled", _8 as "step__nameIndex", _9 as "stepContent__wrapper", _a as "stepContent__footer", _b as "stepContent__segmentMoney", _c as "stepContent__segmentPrice", _d as "stepContent__headerText", _e as "stepContent__headerText_flights", _f as "step__nameLabel", _10 as "step__innerPrice", _11 as "stepContent__segmentHeaderBaggage", _12 as "step__price", _13 as "price", _14 as "stepContent__contentIcon" }
export default { "__esModule": _1, "mobile": _2, "additional": _3, "collapse": _4, "step": _5, "expand": _6, "disabled": _7, "step__nameIndex": _8, "stepContent__wrapper": _9, "stepContent__footer": _a, "stepContent__segmentMoney": _b, "stepContent__segmentPrice": _c, "stepContent__headerText": _d, "stepContent__headerText_flights": _e, "step__nameLabel": _f, "step__innerPrice": _10, "stepContent__segmentHeaderBaggage": _11, "step__price": _12, "price": _13, "stepContent__contentIcon": _14 }
